import { COLORS } from '@/config/colors';
import { css } from './draw-utils';
import type { ProceduralDef } from '../types';

/**
 * Boss damage cracks overlay — frame 0: light cracks (≤66% hp),
 * frame 1: heavy cracks with glowing fissures (≤33% hp).
 * Scaled by code to cover any boss body.
 */
export const fxBossCracks: ProceduralDef = {
  key: 'fx/boss-cracks',
  width: 224,
  height: 224,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const R = c - 20;
    // Deterministic jagged cracks radiating from random-looking fixed seeds
    const seeds: ReadonlyArray<readonly [number, number]> = [
      [0.3, 0.5], [1.7, 0.7], [2.9, 0.45], [4.2, 0.65], [5.3, 0.5],
    ];
    const count = frame === 0 ? 2 : 5;
    for (let s = 0; s < count; s++) {
      const [baseAngle, len] = seeds[s]!;
      ctx.beginPath();
      let x = c + Math.cos(baseAngle) * R * 0.15;
      let y = c + Math.sin(baseAngle) * R * 0.15;
      ctx.moveTo(x, y);
      let a = baseAngle;
      for (let i = 0; i < 5; i++) {
        a += Math.sin(s * 7 + i * 3.1) * 0.7;
        const step = R * len * 0.22;
        x += Math.cos(a) * step;
        y += Math.sin(a) * step;
        ctx.lineTo(x, y);
      }
      ctx.strokeStyle = css(COLORS.outline);
      ctx.lineWidth = frame === 0 ? 4 : 6;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.stroke();
      if (frame === 1) {
        // Glowing fissure core on heavy damage
        ctx.strokeStyle = 'rgba(232, 84, 47, 0.7)';
        ctx.lineWidth = 2.5;
        ctx.stroke();
      }
    }
    void h;
  },
};
